/**
 * 	面对面积分
 */
export default [
  {
    path: '/faceIntegral',
    component: () => import(/* webpackChunkName: "Activity" */ '@/views/faceIntegral/Index.vue'),
    meta: { requiresAuth: true, title: '面对面积分', icon: '', role: true },
    children:
      [
        {
          path: '',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/faceIntegral/Integral.vue'),
          meta: { title: '面对面积分', role: true },
        },
        {
          path: 'IntegralMember',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/faceIntegral/IntegralMember.vue'),
          meta: { title: '面对面积分', role: true },
        },
        {
          path: 'IntegralRecording',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/faceIntegral/IntegralRecording.vue'),
          meta: { title: '面对面积分', role: true },
        },
        {
          path: 'IntegralSuccess',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/faceIntegral/IntegralSuccess.vue'),
          meta: { title: '面对面积分', role: true },
        },
      ],
  },
];